import React from 'react';

export default function CheckBoxInput(props) {
  const { register, errors, name, label, required } = props;
  return (
    <div className="Cmanonymous text-sm text-black mt-6 lg:mt-10">
      <label>
        <input type="checkbox" {...register(`${name}`)} />
        <span className="pr-4">{label}</span>
      </label>
    </div>
  );
}
